import React from 'react'
import PrivateRoute from 'core/routing/private-route'
import { HOME } from 'core/routing/constants'
import Home from '.'

const router = <PrivateRoute exact path={HOME} component={Home} />

export default router
